import { ActionType, createAction } from "typesafe-actions";

import type { ChatGeometry, ChatPreferences, ChatVerticalRect } from "./ChatState";

export const releaseChatHidden = createAction("@chat/releaseHidden")<void>();

export const requestChatHidden = createAction("@chat/requestHidden")<void>();

export const setChatGeometry = createAction("@chat/setGeometry")<ChatGeometry>();

export const setChatOpen = createAction("@chat/setOpen")<boolean>();

// A partial rather than one action per preference. The panel writes one key at a time, and a
// third preference then costs a field instead of a new action, a new reducer branch and a new
// saga trigger. Mobile's updateDeviceOptions carries the same shape.
export const setChatPreferences = createAction("@chat/setPreferences")<Partial<ChatPreferences>>();

export const setChatSettingsOpen = createAction("@chat/setSettingsOpen")<boolean>();

// payload is the vertical rect a maximized window should fill. It derives from viewport
// size, which the reducer cannot see.
export const toggleChatMaximized = createAction("@chat/toggleMaximized")<ChatVerticalRect>();

export type ChatActions = ActionType<
  | typeof releaseChatHidden
  | typeof requestChatHidden
  | typeof setChatGeometry
  | typeof setChatOpen
  | typeof setChatPreferences
  | typeof setChatSettingsOpen
  | typeof toggleChatMaximized
>;
